export function loadGtmHeadScript(
  w: Window & { [key: string]: any},
  d: Document,
  s: string,
  l: string,
  i: string
): void {
  w[l]=w[l]||[];
  w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});

  const f = d.getElementsByTagName(s)[0];
  const j = d.createElement(s) as HTMLScriptElement;
  const dl = l !== 'dataLayer' ? '&l=' + l : '';
  j.async = true;
  j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;

  if (f.parentNode) {
    f.parentNode.insertBefore(j,f);
  }
}